import { Route, Switch } from "react-router-dom";
import PrevisaoOrcamentariaListagemPage from "./Listagem";
import DetalhePrevisaoOrcamentaria from "./DetalhePrevisaoOrcamentaria";

function PrevisaoOrcamentariaPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/previsao-orcamentaria"
        component={PrevisaoOrcamentariaListagemPage}
      />
      <Route
        exact
        path="/financeiro/previsao-orcamentaria/:id"
        component={DetalhePrevisaoOrcamentaria}
      />
    </Switch>
  );
}

export default PrevisaoOrcamentariaPages;
